import Accordion from 'accordion-js';

const faqs = document.querySelectorAll('.wp-block-yoast-faq-block');
if(faqs.length > 0 ){
	faqs.forEach( faq => {
		new Accordion(faq, {
			'elementClass': 'schema-faq-section',
			'triggerClass': 'schema-faq-question',
			'panelClass': 'schema-faq-answer',
			'openOnInit': [0]
		});
	});
}
